// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from 'grommet';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import ActionButtons from 'esm-web-pro/components/forms/ActionButtons';
import { FILTER_OBJECTS_PANEL_KEY } from './FilterObjectsContainer';

type Props = {
    onClose: Function,
    onSubmit: Function,
    children: React.Node,
}

const FilterObjectsSidePanelContainer = (props: Props) => {
    const { onClose, onSubmit, children } = props;

    return (
        <SidePane
            id={FILTER_OBJECTS_PANEL_KEY}
            openInitially
            title={(<FormattedMessage id="filter-objects-title" defaultMessage="Filter objects" />)}
            closePanel={FILTER_OBJECTS_PANEL_KEY}
        >
            <Box height="100%">
                <Box
                    direction="row"
                    align="center"
                    height="100%"
                    style={{ position: 'unset' }}
                >
                    <Box
                        className="BOX2"
                        alignSelf="stretch"
                        flex
                        justify="between"
                        as="form"
                    >
                        <Box
                            pad={{ horizontal: 'medium', bottom: 'xlarge', top: 'xsmall' }}
                            overflow="scroll"
                            height="100%"
                        >
                            { children }
                        </Box>
                        <ActionButtons
                            onClose={onClose}
                            onSave={onSubmit}
                            cancelButtonLabel={<FormattedMessage id="filters-btn-reset" default="Reset" />}
                            saveButtonLabel={<FormattedMessage id="filters-btn-filter" defaultMessage="Filter" />}
                        />
                    </Box>
                </Box>
            </Box>
        </SidePane>
    );
};

export default FilterObjectsSidePanelContainer;
